<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的人员信息</span>
    </div>
    <div class="checkCI">
      <Input v-model="idCardName" placeholder="姓名" style="width: 200px;margin-left: 5px"/>
      <Input v-model="citizenNo" placeholder="请输入身份证号" style="width: 200px;margin-left: 5px"/>
      <Input v-model="rcdNm" placeholder="省行政区划代码(6位数字)(发证省)" style="width: 240px;margin-left: 5px"/>
      <DatePicker v-model="vdtTm" format="yyyyMMdd" type="date" placeholder="证件有效期"
                  style="width: 200px;margin-left: 5px;"></DatePicker>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultTwo">{{resultTwo}}</div>
  </div>
</template>
<script>
  import {apiPost} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkQI',
    data() {
      return {
        citizenNo: '',
        idCardName: '',
        rcdNm: '',
        vdtTm: '',
        resultTwo: ''
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.citizenNo || !this.idCardName || !this.rcdNm) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后将查询").then((type) => {
          if (type === "confirm") {
            this.checkQualificationV3();
          }
        });
      },
      async checkQualificationV3() {
        let params = {
          method: 'checkQualificationV3',
          params: {
            citizenNo: this.citizenNo,
            idCardName: this.idCardName,
            rcdNm: this.rcdNm,
            vdtTm: this.$utils.toDateString(this.vdtTm, "yyyyMMdd")
          }
        }
        showLoading();
        let res = await apiPost("api/order/track/", params.method, params.params);
        hideLoading();
        if (res && res.status === 1) {
          let resData = JSON.parse(res.data);
          if (resData.status === 1001) {
            let data = resData.result;
            let code = parseInt(data.code);
            if (code === 10000) {
              let seqNo = data.seqNo ? data.seqNo : '';//序列号
              let certificateState = data.certificateState ? data.certificateState : '';//证照状态
              let issueDartp = data.issueDartp ? data.issueDartp : '';//发证机关
              let maturityWarning = data.maturityWarning ? (parseInt(data.maturityWarning) === 0 ? '有效期超过半月' : '有效期不足半月') : '';//到期预警
              let verifiedValidityDate = data.verifiedValidityDate ? (data.verifiedValidityDate === 0 ? '不一致' : '一致') : '';//有效期核验
              let checkTime = data.checkTime ? this.timestampToTime(parseInt(data.checkTime)) : '';//验证时间
              let quasiDriveType = data.quasiDriveType ? data.quasiDriveType : '';//准驾车型
              let license = data.license ? data.license : '';//从业资格证号
              let licensedateOfissue = data.licensedateOfissue ? data.licensedateOfissue : '';//从业资格证发证日期
              let certificateExpireDate = data.certificateExpireDate ? data.certificateExpireDate : '';//证件有效期至
              let vehicleBusinessScope = data.vehicleBusinessScope ? data.vehicleBusinessScope : '';//经营范围
              this.resultTwo = "序列号：" + seqNo + '\n证照状态：' + certificateState +
                '\n发证机关：' + issueDartp + '\t\t到期预警：' + maturityWarning + '\t\t有效期核验:' + verifiedValidityDate + '\t\t验证时间:' + checkTime +
                '\n准驾车型:' + quasiDriveType + '\t\t从业资格证号:' + license +
                '\n从业资格证发证日期:' + licensedateOfissue + '\t\t证件有效期至:' + certificateExpireDate +
                '\n经营范围:' + vehicleBusinessScope;
            } else if (code === 10001) {
              this.resultTwo = "查询无结果";
            } else if (code === 10002) {
              this.resultTwo = "参数有误";
            } else if (code === 10003) {
              this.resultTwo = "请求错误";
            } else if (code === 10004) {
              this.resultTwo = "系统错误";
            }
          } else if (res.status === 1006) {
            this.resultTwo = "无结果";
          } else {
            this.resultTwo = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
      timestampToTime(timestamp) {
        let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? ('0' + date.getDate()) + ' ' : date.getDate() + ' ';
        let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      },
    }
  }
</script>
<style scoped>
  .checkCI {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultTwo {
    height: 20%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }
</style>